import { render, staticRenderFns } from "./Rozmery.vue?vue&type=template&id=702e39c6&scoped=true&"
import script from "./Rozmery.vue?vue&type=script&lang=ts&"
export * from "./Rozmery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702e39c6",
  null
  
)

export default component.exports